import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
  },
  image: {
    borderRadius: theme.shape.borderRadius,
  },
}));

// A single card-shaped placeholder: image block + two lines of text,
// used for grid/card loading states (e.g. PoS item grid).
const CardSkeleton = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Skeleton className={classes.image} variant="rect" height={110} animation="wave" />
      <Skeleton variant="text" height={28} width="80%" animation="wave" />
      <Skeleton variant="text" height={20} width="40%" animation="wave" />
    </div>
  );
};

export default CardSkeleton;
